import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../../assets/css/dashboard.css';
import AssignSalesRep from '../forms/assignSalesRep/AssignSalesRepContainer';

const AssignRmModal = (props) => {
	return (
		<div>
			<Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header closeButton>
					<Modal.Title>
						<h5 className="text-grey">Assign a Sales Representative</h5>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<AssignSalesRep lead_ref={props.lead_ref} />
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default AssignRmModal;
